let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g8EfE")).then(() => parcelRequire('1xHQr'));